module.exports = __webpack_public_path__ + "img/D5.d08b1cce.svg";